<div class="page-header">
  @if (pageTitle) {
    <div class="page-header-title d-flex align-items-center">
      <span class="h3" [title]="pageTitle | translate" [innerHTML]="pageTitle | translate"></span>
      <div>
        <ng-container [ngTemplateOutlet]="entryCountElement"></ng-container>
      </div>
    </div>
  }

  @if (!pageTitle) {
    <ng-content select="[header-title]"></ng-content>
  }

  <div class="page-functions">
    @for (element of elements; track element) {
      <div class="filter-element">
        <ng-container [ngTemplateOutlet]="element"></ng-container>
      </div>
    }
  </div>
</div>
